import React from 'react';
import styled from 'styled-components/macro';
import {
  Heading1,
  Paragraph,
  Heading2,
  LinkStyled,
} from '../../components/typography';
import {
  Container,
  Row,
  Col,
} from '../../components/grid';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import { Item } from '../../containers/commerce';
import ProductViewKulsyre from '../../components/commerce/ProductViews/ProductViewKulsyre';
import { Content } from './Kulsyre';
import { Image } from '../../components/Image';

const Grid = styled.div`
  display: grid;
  grid-gap: 30px;
  grid-template-columns: repeat(4, 1fr);
  margin: 15px 0;

  @media (max-width: 1599px) {
    grid-gap: 15px;
    margin: 0;
  }

  @media (max-width: 1199px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 575px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const ImageGrid = styled.div`
  display: grid;
  grid-gap: 30px;
  grid-template-columns: repeat(2, 1fr);

  & img {
    border-radius: 15px;
  }

  @media (max-width: 1599px) {
    grid-gap: 15px;
    margin: 0;
  }

  @media (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const VerticalImageGrid = styled.div`
  display: grid;
  grid-gap: 30px;
  grid-template-columns: repeat(2, 1fr);

  @media (max-width: 1599px) {
    grid-gap: 15px;
    margin: 0;
  }
`;


export default () => (
  <SidemenuLayout menuPicker="Kulsyre" activeSidemenu="OpfyldningKulsyre">
    <Container white mb>
      <Row>
        <Col xs={12} id="salg-af-kulsyre" paddingBottom="0px">
          <Heading1 margin="0 0 10px">Opfyldning af kulsyreflasker</Heading1>
          <Heading2>Vi fylder din egen kulsyreflaske</Heading2>
        </Col>
        <Col xs={12} paddingTop="0px" paddingBottom="0px">
          <Paragraph>
            Vi kan opfylde din egen kulsyreflaske med CO<sub>2</sub>. Eneste betingelse er at den er trykprøvet for under 10 år siden.
          </Paragraph>
          <Paragraph>
            Ofte fylder vi mens du venter på lageret. Dog ikke mandage og fredage i de travle perioder.
          </Paragraph>
          <Paragraph>
            Vi fylder din flaske på vores fyldeanlæg (se billeder nederst på siden), med kulsyre (CO<sub>2</sub>) som er levnesmiddelgodkendt. Vi sælger også <LinkStyled to="/kulsyre">kulsyre</LinkStyled> i størrelserne 4kg og 6kg, hvis du ikke har din egen flaske.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <Grid>
            <Content product>
              <Item varenr="8962" display={ProductViewKulsyre} />
            </Content>
            <Content product>
              <Item varenr="8964" display={ProductViewKulsyre} />
            </Content>
            <Content product>
              <Item varenr="8966" display={ProductViewKulsyre} />
            </Content>
            <Content product>
              <Item varenr="8970" display={ProductViewKulsyre} />
            </Content>
          </Grid>
        </Col>
      </Row>
    </Container>
    <Container>
      <Row>
        <Col xs={12} padding="0px">
          <ImageGrid>
            <Image name="kulsyre.opfyldning-kulsyre-1.png" alt="Opfyldning kulsyre 1" imageHeight="450px" />
            <VerticalImageGrid>
              <Image name="kulsyre.opfyldning-kulsyre-2.png" alt="Opfyldning kulsyre 1" imageHeight="450px" />
              <Image name="kulsyre.opfyldning-kulsyre-3.png" alt="Opfyldning kulsyre 1" imageHeight="450px" />
            </VerticalImageGrid>
          </ImageGrid>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
